import clsx from "clsx";
import { ViewportEdgeNav } from "@/components/ViewportEdgeNav";
import type { ProjectDetailTab } from "@/pages/projekte/projectDetailTabs";
import { PROJECT_DETAIL_TABS } from "@/pages/projekte/projectDetailTabs";

export function ProjectDetailNav({
  active,
  onChange,
  counts,
  includeNotesTab = false,
  includeBueroTabs = false,
}: {
  active: ProjectDetailTab;
  onChange: (tab: ProjectDetailTab) => void;
  counts?: Partial<Record<ProjectDetailTab, number>>;
  /** Notizen-Tab mit anzeigen (Mobil). */
  includeNotesTab?: boolean;
  /** Büro-Tabs (z. B. Dokumente) einblenden. */
  includeBueroTabs?: boolean;
}) {
  const tabs = PROJECT_DETAIL_TABS.filter(
    (tab) => (includeNotesTab || !tab.mobileOnly) && (includeBueroTabs || !tab.bueroOnly),
  );

  return (
    <ViewportEdgeNav>
      <nav className="eh-project-detail-nav eh-project-detail-nav--project" aria-label="Projektbereiche">
        <ul className="eh-project-detail-nav__list" role="list">
          {tabs.map((tab) => {
            const count = counts?.[tab.id];
            const isActive = active === tab.id;
            return (
              <li key={tab.id}>
                <button
                  type="button"
                  className={clsx(
                    "eh-project-detail-nav__item",
                    isActive && "eh-project-detail-nav__item--active",
                  )}
                  aria-current={isActive ? "page" : undefined}
                  onClick={() => onChange(tab.id)}
                >
                  <span className="eh-project-detail-nav__label">{tab.label}</span>
                  {count != null && count > 0 ? (
                    <span className="eh-nav-badge eh-nav-badge--accent">
                      {count > 99 ? "99+" : count}
                    </span>
                  ) : null}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
    </ViewportEdgeNav>
  );
}
